import EstimatedProfitsError from './EstimatedProfitsError';
class EstimatedProfitsPropertyNotFound extends EstimatedProfitsError {
    propertyId;
    constructor(propertyId, options) {
        super('CROWDFUNDING_PROPERTY_NOT_FOUND', options);
        this.propertyId = propertyId;
    }
}
export default EstimatedProfitsPropertyNotFound;
